import React from 'react';

function AddNewRole(props) {
    return (
        <div></div>
    );
}

export default AddNewRole;